module.exports = "/virtual-football-league/img/jerseys/Black_And_White.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/jerseys/Black_And_White.png
// module id = 2238
// module chunks = 4